//http://semplicewebsites.com/sites/default/files/latinise.js_.txt

import { Injectable } from '@angular/core';

/**
 * CaracteresEspeciais
 *
 * Manipula caracteres especiais
 *
 * @access public
 * @author Murilo Spinoza de Arruda
 * @since  09/2017
 * @return void
 */
Injectable()
export class CaracteresEspeciais {

	private charsMap = {
		'Ã': 'A',
		'Ä‚': 'A',
		'áº®': 'A',
		'áº¶': 'A',
		'áº°': 'A',
		'áº²': 'A',
		'áº´': 'A',
		'Ç': 'A',
		'Ã‚': 'A',
		'áº¤': 'A',
		'áº¬': 'A',
		'áº¦': 'A',
		'áº¨': 'A',
		'áºª': 'A',
		'Ã„': 'A',
		'Çž': 'A',
		'È¦': 'A',
		'Ç ': 'A',
		'áº ': 'A',
		'È€': 'A',
		'Ã€': 'A',
		'áº¢': 'A',
		'È‚': 'A',
		'Ä€': 'A',
		'Ä„': 'A',
		'Ã…': 'A',
		'Çº': 'A',
		'á¸€': 'A',
		'Èº': 'A',
		'Ãƒ': 'A',
		'êœ²': 'AA',
		'Ã†': 'AE',
		'Ç¼': 'AE',
		'Ç¢': 'AE',
		'êœ´': 'AO',
		'êœ¶': 'AU',
		'êœ¸': 'AV',
		'êœº': 'AV',
		'êœ¼': 'AY',
		'á¸‚': 'B',
		'á¸„': 'B',
		'Æ': 'B',
		'á¸†': 'B',
		'Éƒ': 'B',
		'Æ‚': 'B',
		'Ä†': 'C',
		'ÄŒ': 'C',
		'Ã‡': 'C',
		'á¸ˆ': 'C',
		'Äˆ': 'C',
		'ÄŠ': 'C',
		'Æ‡': 'C',
		'È»': 'C',
		'ÄŽ': 'D',
		'á¸': 'D',
		'á¸’': 'D',
		'á¸Š': 'D',
		'á¸Œ': 'D',
		'ÆŠ': 'D',
		'á¸Ž': 'D',
		'Ç²': 'D',
		'Ç…': 'D',
		'Ä': 'D',
		'Æ‹': 'D',
		'Ç±': 'DZ',
		'Ç„': 'DZ',
		'Ã‰': 'E',
		'Ä”': 'E',
		'Äš': 'E',
		'È¨': 'E',
		'á¸œ': 'E',
		'ÃŠ': 'E',
		'áº¾': 'E',
		'á»†': 'E',
		'á»€': 'E',
		'á»‚': 'E',
		'á»„': 'E',
		'á¸˜': 'E',
		'Ã‹': 'E',
		'Ä–': 'E',
		'áº¸': 'E',
		'È„': 'E',
		'Ãˆ': 'E',
		'áºº': 'E',
		'È†': 'E',
		'Ä’': 'E',
		'á¸–': 'E',
		'á¸”': 'E',
		'Ä˜': 'E',
		'É†': 'E',
		'áº¼': 'E',
		'á¸š': 'E',
		'êª': 'ET',
		'á¸ž': 'F',
		'Æ‘': 'F',
		'Ç´': 'G',
		'Äž': 'G',
		'Ç¦': 'G',
		'Ä¢': 'G',
		'Äœ': 'G',
		'Ä ': 'G',
		'Æ“': 'G',
		'á¸ ': 'G',
		'Ç¤': 'G',
		'á¸ª': 'H',
		'Èž': 'H',
		'á¸¨': 'H',
		'Ä¤': 'H',
		'â±§': 'H',
		'á¸¦': 'H',
		'á¸¢': 'H',
		'á¸¤': 'H',
		'Ä¦': 'H',
		'Ã': 'I',
		'Ä¬': 'I',
		'Ç': 'I',
		'ÃŽ': 'I',
		'Ã': 'I',
		'á¸®': 'I',
		'Ä°': 'I',
		'á»Š': 'I',
		'Èˆ': 'I',
		'ÃŒ': 'I',
		'á»ˆ': 'I',
		'ÈŠ': 'I',
		'Äª': 'I',
		'Ä®': 'I',
		'Æ—': 'I',
		'Ä¨': 'I',
		'á¸¬': 'I',
		'ê¹': 'D',
		'ê»': 'F',
		'ê½': 'G',
		'êž‚': 'R',
		'êž„': 'S',
		'êž†': 'T',
		'ê¬': 'IS',
		'Ä´': 'J',
		'Éˆ': 'J',
		'á¸°': 'K',
		'Ç¨': 'K',
		'Ä¶': 'K',
		'â±©': 'K',
		'ê‚': 'K',
		'á¸²': 'K',
		'Æ˜': 'K',
		'á¸´': 'K',
		'ê€': 'K',
		'ê„': 'K',
		'Ä¹': 'L',
		'È½': 'L',
		'Ä½': 'L',
		'Ä»': 'L',
		'á¸¼': 'L',
		'á¸¶': 'L',
		'á¸¸': 'L',
		'â± ': 'L',
		'êˆ': 'L',
		'á¸º': 'L',
		'Ä¿': 'L',
		'â±¢': 'L',
		'Çˆ': 'L',
		'Å': 'L',
		'Ç‡': 'LJ',
		'á¸¾': 'M',
		'á¹€': 'M',
		'á¹‚': 'M',
		'â±®': 'M',
		'Åƒ': 'N',
		'Å‡': 'N',
		'Å…': 'N',
		'á¹Š': 'N',
		'á¹„': 'N',
		'á¹†': 'N',
		'Ç¸': 'N',
		'Æ': 'N',
		'á¹ˆ': 'N',
		'È ': 'N',
		'Ç‹': 'N',
		'Ã‘': 'N',
		'ÇŠ': 'NJ',
		'Ã“': 'O',
		'ÅŽ': 'O',
		'Ç‘': 'O',
		'Ã”': 'O',
		'á»': 'O',
		'á»˜': 'O',
		'á»’': 'O',
		'á»”': 'O',
		'á»–': 'O',
		'Ã–': 'O',
		'Èª': 'O',
		'È®': 'O',
		'È°': 'O',
		'á»Œ': 'O',
		'Å': 'O',
		'ÈŒ': 'O',
		'Ã’': 'O',
		'á»Ž': 'O',
		'Æ ': 'O',
		'á»š': 'O',
		'á»¢': 'O',
		'á»œ': 'O',
		'á»ž': 'O',
		'á» ': 'O',
		'ÈŽ': 'O',
		'êŠ': 'O',
		'êŒ': 'O',
		'ÅŒ': 'O',
		'á¹’': 'O',
		'á¹': 'O',
		'ÆŸ': 'O',
		'Çª': 'O',
		'Ç¬': 'O',
		'Ã˜': 'O',
		'Ç¾': 'O',
		'Ã•': 'O',
		'á¹Œ': 'O',
		'á¹Ž': 'O',
		'È¬': 'O',
		'Æ¢': 'OI',
		'êŽ': 'OO',
		'Æ': 'E',
		'Æ†': 'O',
		'È¢': 'OU',
		'á¹”': 'P',
		'á¹–': 'P',
		'ê’': 'P',
		'Æ¤': 'P',
		'ê”': 'P',
		'â±£': 'P',
		'ê': 'P',
		'ê˜': 'Q',
		'ê–': 'Q',
		'Å”': 'R',
		'Å˜': 'R',
		'Å–': 'R',
		'á¹˜': 'R',
		'á¹š': 'R',
		'á¹œ': 'R',
		'È': 'R',
		'È’': 'R',
		'á¹ž': 'R',
		'ÉŒ': 'R',
		'â±¤': 'R',
		'êœ¾': 'C',
		'ÆŽ': 'E',
		'Åš': 'S',
		'á¹¤': 'S',
		'Å ': 'S',
		'á¹¦': 'S',
		'Åž': 'S',
		'Åœ': 'S',
		'È˜': 'S',
		'á¹ ': 'S',
		'á¹¢': 'S',
		'á¹¨': 'S',
		'áºž': 'SS',
		'Å¤': 'T',
		'Å¢': 'T',
		'á¹°': 'T',
		'Èš': 'T',
		'È¾': 'T',
		'á¹ª': 'T',
		'á¹¬': 'T',
		'Æ¬': 'T',
		'á¹®': 'T',
		'Æ®': 'T',
		'Å¦': 'T',
		'â±¯': 'A',
		'êž€': 'L',
		'Æœ': 'M',
		'É…': 'V',
		'êœ¨': 'TZ',
		'Ãš': 'U',
		'Å¬': 'U',
		'Ç“': 'U',
		'Ã›': 'U',
		'á¹¶': 'U',
		'Ãœ': 'U',
		'Ç—': 'U',
		'Ç™': 'U',
		'Ç›': 'U',
		'Ç•': 'U',
		'á¹²': 'U',
		'á»¤': 'U',
		'Å°': 'U',
		'È”': 'U',
		'Ã™': 'U',
		'á»¦': 'U',
		'Æ¯': 'U',
		'á»¨': 'U',
		'á»°': 'U',
		'á»ª': 'U',
		'á»¬': 'U',
		'á»®': 'U',
		'È–': 'U',
		'Åª': 'U',
		'á¹º': 'U',
		'Å²': 'U',
		'Å®': 'U',
		'Å¨': 'U',
		'á¹¸': 'U',
		'á¹´': 'U',
		'êž': 'V',
		'á¹¾': 'V',
		'Æ²': 'V',
		'á¹¼': 'V',
		'ê ': 'VY',
		'áº‚': 'W',
		'Å´': 'W',
		'áº„': 'W',
		'áº†': 'W',
		'áºˆ': 'W',
		'áº€': 'W',
		'â±²': 'W',
		'áºŒ': 'X',
		'áºŠ': 'X',
		'Ã': 'Y',
		'Å¶': 'Y',
		'Å¸': 'Y',
		'áºŽ': 'Y',
		'á»´': 'Y',
		'á»²': 'Y',
		'Æ³': 'Y',
		'á»¶': 'Y',
		'á»¾': 'Y',
		'È²': 'Y',
		'ÉŽ': 'Y',
		'á»¸': 'Y',
		'Å¹': 'Z',
		'Å½': 'Z',
		'áº': 'Z',
		'â±«': 'Z',
		'Å»': 'Z',
		'áº’': 'Z',
		'È¤': 'Z',
		'áº”': 'Z',
		'Æµ': 'Z',
		'Ä²': 'IJ',
		'Å’': 'OE',
		'á´€': 'A',
		'á´': 'AE',
		'Ê™': 'B',
		'á´ƒ': 'B',
		'á´„': 'C',
		'á´…': 'D',
		'á´‡': 'E',
		'êœ°': 'F',
		'É¢': 'G',
		'Ê›': 'G',
		'Êœ': 'H',
		'Éª': 'I',
		'Ê': 'R',
		'á´Š': 'J',
		'á´‹': 'K',
		'ÊŸ': 'L',
		'á´Œ': 'L',
		'á´': 'M',
		'É´': 'N',
		'á´': 'O',
		'É¶': 'OE',
		'á´': 'O',
		'á´•': 'OU',
		'á´˜': 'P',
		'Ê€': 'R',
		'á´Ž': 'N',
		'á´™': 'R',
		'êœ±': 'S',
		'á´›': 'T',
		'â±»': 'E',
		'á´š': 'R',
		'á´œ': 'U',
		'á´ ': 'V',
		'á´¡': 'W',
		'Ê': 'Y',
		'á´¢': 'Z',
		'Ã¡': 'a',
		'Äƒ': 'a',
		'áº¯': 'a',
		'áº·': 'a',
		'áº±': 'a',
		'áº³': 'a',
		'áºµ': 'a',
		'ÇŽ': 'a',
		'Ã¢': 'a',
		'áº¥': 'a',
		'áº­': 'a',
		'áº§': 'a',
		'áº©': 'a',
		'áº«': 'a',
		'Ã¤': 'a',
		'ÇŸ': 'a',
		'È§': 'a',
		'Ç¡': 'a',
		'áº¡': 'a',
		'È': 'a',
		'Ã ': 'a',
		'áº£': 'a',
		'Èƒ': 'a',
		'Ä': 'a',
		'Ä…': 'a',
		'á¶': 'a',
		'áºš': 'a',
		'Ã¥': 'a',
		'Ç»': 'a',
		'á¸': 'a',
		'â±¥': 'a',
		'Ã£': 'a',
		'êœ³': 'aa',
		'Ã¦': 'ae',
		'Ç½': 'ae',
		'Ç£': 'ae',
		'êœµ': 'ao',
		'êœ·': 'au',
		'êœ¹': 'av',
		'êœ»': 'av',
		'êœ½': 'ay',
		'á¸ƒ': 'b',
		'á¸…': 'b',
		'É“': 'b',
		'á¸‡': 'b',
		'áµ¬': 'b',
		'á¶€': 'b',
		'Æ€': 'b',
		'Æƒ': 'b',
		'Éµ': 'o',
		'Ä‡': 'c',
		'Ä': 'c',
		'Ã§': 'c',
		'á¸‰': 'c',
		'Ä‰': 'c',
		'É•': 'c',
		'Ä‹': 'c',
		'Æˆ': 'c',
		'È¼': 'c',
		'Ä': 'd',
		'á¸‘': 'd',
		'á¸“': 'd',
		'È¡': 'd',
		'á¸‹': 'd',
		'á¸': 'd',
		'É—': 'd',
		'á¶‘': 'd',
		'á¸': 'd',
		'áµ­': 'd',
		'á¶': 'd',
		'Ä‘': 'd',
		'É–': 'd',
		'ÆŒ': 'd',
		'Ä±': 'i',
		'È·': 'j',
		'ÉŸ': 'j',
		'Ê„': 'j',
		'Ç³': 'dz',
		'Ç†': 'dz',
		'Ã©': 'e',
		'Ä•': 'e',
		'Ä›': 'e',
		'È©': 'e',
		'á¸': 'e',
		'Ãª': 'e',
		'áº¿': 'e',
		'á»‡': 'e',
		'á»': 'e',
		'á»ƒ': 'e',
		'á»…': 'e',
		'á¸™': 'e',
		'Ã«': 'e',
		'Ä—': 'e',
		'áº¹': 'e',
		'È…': 'e',
		'Ã¨': 'e',
		'áº»': 'e',
		'È‡': 'e',
		'Ä“': 'e',
		'á¸—': 'e',
		'á¸•': 'e',
		'â±¸': 'e',
		'Ä™': 'e',
		'á¶’': 'e',
		'É‡': 'e',
		'áº½': 'e',
		'á¸›': 'e',
		'ê«': 'et',
		'á¸Ÿ': 'f',
		'Æ’': 'f',
		'áµ®': 'f',
		'á¶‚': 'f',
		'Çµ': 'g',
		'ÄŸ': 'g',
		'Ç§': 'g',
		'Ä£': 'g',
		'Ä': 'g',
		'Ä¡': 'g',
		'É ': 'g',
		'á¸¡': 'g',
		'á¶ƒ': 'g',
		'Ç¥': 'g',
		'á¸«': 'h',
		'ÈŸ': 'h',
		'á¸©': 'h',
		'Ä¥': 'h',
		'â±¨': 'h',
		'á¸§': 'h',
		'á¸£': 'h',
		'á¸¥': 'h',
		'É¦': 'h',
		'áº–': 'h',
		'Ä§': 'h',
		'Æ•': 'hv',
		'Ã­': 'i',
		'Ä­': 'i',
		'Ç': 'i',
		'Ã®': 'i',
		'Ã¯': 'i',
		'á¸¯': 'i',
		'á»‹': 'i',
		'È‰': 'i',
		'Ã¬': 'i',
		'á»‰': 'i',
		'È‹': 'i',
		'Ä«': 'i',
		'Ä¯': 'i',
		'á¶–': 'i',
		'É¨': 'i',
		'Ä©': 'i',
		'á¸­': 'i',
		'êº': 'd',
		'ê¼': 'f',
		'áµ¹': 'g',
		'êžƒ': 'r',
		'êž…': 's',
		'êž‡': 't',
		'ê­': 'is',
		'Ç°': 'j',
		'Äµ': 'j',
		'Ê': 'j',
		'É‰': 'j',
		'á¸±': 'k',
		'Ç©': 'k',
		'Ä·': 'k',
		'â±ª': 'k',
		'êƒ': 'k',
		'á¸³': 'k',
		'Æ™': 'k',
		'á¸µ': 'k',
		'á¶„': 'k',
		'ê': 'k',
		'ê…': 'k',
		'Äº': 'l',
		'Æš': 'l',
		'É¬': 'l',
		'Ä¾': 'l',
		'Ä¼': 'l',
		'á¸½': 'l',
		'È´': 'l',
		'á¸·': 'l',
		'á¸¹': 'l',
		'â±¡': 'l',
		'ê‰': 'l',
		'á¸»': 'l',
		'Å€': 'l',
		'É«': 'l',
		'á¶…': 'l',
		'É­': 'l',
		'Å‚': 'l',
		'Ç‰': 'lj',
		'Å¿': 's',
		'áºœ': 's',
		'áº›': 's',
		'áº': 's',
		'á¸¿': 'm',
		'á¹': 'm',
		'á¹ƒ': 'm',
		'É±': 'm',
		'áµ¯': 'm',
		'á¶†': 'm',
		'Å„': 'n',
		'Åˆ': 'n',
		'Å†': 'n',
		'á¹‹': 'n',
		'Èµ': 'n',
		'á¹…': 'n',
		'á¹‡': 'n',
		'Ç¹': 'n',
		'É²': 'n',
		'á¹‰': 'n',
		'Æž': 'n',
		'áµ°': 'n',
		'á¶‡': 'n',
		'É³': 'n',
		'Ã±': 'n',
		'ÇŒ': 'nj',
		'Ã³': 'o',
		'Å': 'o',
		'Ç’': 'o',
		'Ã´': 'o',
		'á»‘': 'o',
		'á»™': 'o',
		'á»“': 'o',
		'á»•': 'o',
		'á»—': 'o',
		'Ã¶': 'o',
		'È«': 'o',
		'È¯': 'o',
		'È±': 'o',
		'á»': 'o',
		'Å‘': 'o',
		'È': 'o',
		'Ã²': 'o',
		'á»': 'o',
		'Æ¡': 'o',
		'á»›': 'o',
		'á»£': 'o',
		'á»': 'o',
		'á»Ÿ': 'o',
		'á»¡': 'o',
		'È': 'o',
		'ê‹': 'o',
		'ê': 'o',
		'â±º': 'o',
		'Å': 'o',
		'á¹“': 'o',
		'á¹‘': 'o',
		'Ç«': 'o',
		'Ç­': 'o',
		'Ã¸': 'o',
		'Ç¿': 'o',
		'Ãµ': 'o',
		'á¹': 'o',
		'á¹': 'o',
		'È­': 'o',
		'Æ£': 'oi',
		'ê': 'oo',
		'É›': 'e',
		'á¶“': 'e',
		'É”': 'o',
		'á¶—': 'o',
		'È£': 'ou',
		'á¹•': 'p',
		'á¹—': 'p',
		'ê“': 'p',
		'Æ¥': 'p',
		'áµ±': 'p',
		'á¶ˆ': 'p',
		'ê•': 'p',
		'áµ½': 'p',
		'ê‘': 'p',
		'ê™': 'q',
		'Ê ': 'q',
		'É‹': 'q',
		'ê—': 'q',
		'Å•': 'r',
		'Å™': 'r',
		'Å—': 'r',
		'á¹™': 'r',
		'á¹›': 'r',
		'á¹': 'r',
		'È‘': 'r',
		'É¾': 'r',
		'áµ³': 'r',
		'È“': 'r',
		'á¹Ÿ': 'r',
		'É¼': 'r',
		'áµ²': 'r',
		'á¶‰': 'r',
		'É': 'r',
		'É½': 'r',
		'â†„': 'c',
		'êœ¿': 'c',
		'É˜': 'e',
		'É¿': 'r',
		'Å›': 's',
		'á¹¥': 's',
		'Å¡': 's',
		'á¹§': 's',
		'ÅŸ': 's',
		'Å': 's',
		'È™': 's',
		'á¹¡': 's',
		'á¹£': 's',
		'á¹©': 's',
		'Ê‚': 's',
		'áµ´': 's',
		'á¶Š': 's',
		'È¿': 's',
		'É¡': 'g',
		'ÃŸ': 'ss',
		'á´‘': 'o',
		'á´“': 'o',
		'á´': 'u',
		'Å¥': 't',
		'Å£': 't',
		'á¹±': 't',
		'È›': 't',
		'È¶': 't',
		'áº—': 't',
		'â±¦': 't',
		'á¹«': 't',
		'á¹­': 't',
		'Æ­': 't',
		'á¹¯': 't',
		'áµµ': 't',
		'Æ«': 't',
		'Êˆ': 't',
		'Å§': 't',
		'áµº': 'th',
		'É': 'a',
		'á´‚': 'ae',
		'Ç': 'e',
		'áµ·': 'g',
		'É¥': 'h',
		'Ê®': 'h',
		'Ê¯': 'h',
		'á´‰': 'i',
		'Êž': 'k',
		'êž': 'l',
		'É¯': 'm',
		'É°': 'm',
		'á´”': 'oe',
		'É¹': 'r',
		'É»': 'r',
		'Éº': 'r',
		'â±¹': 'r',
		'Ê‡': 't',
		'ÊŒ': 'v',
		'Ê': 'w',
		'ÊŽ': 'y',
		'êœ©': 'tz',
		'Ãº': 'u',
		'Å­': 'u',
		'Ç”': 'u',
		'Ã»': 'u',
		'á¹·': 'u',
		'Ã¼': 'u',
		'Ç˜': 'u',
		'Çš': 'u',
		'Çœ': 'u',
		'Ç–': 'u',
		'á¹³': 'u',
		'á»¥': 'u',
		'Å±': 'u',
		'È•': 'u',
		'Ã¹': 'u',
		'á»§': 'u',
		'Æ°': 'u',
		'á»©': 'u',
		'á»±': 'u',
		'á»«': 'u',
		'á»­': 'u',
		'á»¯': 'u',
		'È—': 'u',
		'Å«': 'u',
		'á¹»': 'u',
		'Å³': 'u',
		'á¶™': 'u',
		'Å¯': 'u',
		'Å©': 'u',
		'á¹¹': 'u',
		'á¹µ': 'u',
		'áµ«': 'ue',
		'ê¸': 'um',
		'â±´': 'v',
		'êŸ': 'v',
		'á¹¿': 'v',
		'Ê‹': 'v',
		'á¶Œ': 'v',
		'â±±': 'v',
		'á¹½': 'v',
		'ê¡': 'vy',
		'áºƒ': 'w',
		'Åµ': 'w',
		'áº…': 'w',
		'áº‡': 'w',
		'áº‰': 'w',
		'áº': 'w',
		'â±³': 'w',
		'áº˜': 'w',
		'áº': 'x',
		'áº‹': 'x',
		'á¶': 'x',
		'Ã½': 'y',
		'Å·': 'y',
		'Ã¿': 'y',
		'áº': 'y',
		'á»µ': 'y',
		'á»³': 'y',
		'Æ´': 'y',
		'á»·': 'y',
		'á»¿': 'y',
		'È³': 'y',
		'áº™': 'y',
		'É': 'y',
		'á»¹': 'y',
		'Åº': 'z',
		'Å¾': 'z',
		'áº‘': 'z',
		'Ê‘': 'z',
		'â±¬': 'z',
		'Å¼': 'z',
		'áº“': 'z',
		'È¥': 'z',
		'áº•': 'z',
		'áµ¶': 'z',
		'á¶Ž': 'z',
		'Ê': 'z',
		'Æ¶': 'z',
		'É€': 'z',
		'ï¬€': 'ff',
		'ï¬ƒ': 'ffi',
		'ï¬„': 'ffl',
		'ï¬': 'fi',
		'ï¬‚': 'fl',
		'Ä³': 'ij',
		'Å“': 'oe',
		'ï¬†': 'st',
		'â‚': 'a',
		'â‚‘': 'e',
		'áµ¢': 'i',
		'â±¼': 'j',
		'â‚’': 'o',
		'áµ£': 'r',
		'áµ¤': 'u',
		'áµ¥': 'v',
		'â‚“': 'x',

		//Mais comuns
		'á': 'a',
		'à': 'a',
		'ã': 'a',
		'â': 'a',
		'ä': 'a',
		'é': 'e',
		'è': 'e',
		'ê': 'e',
		'ẽ': 'e',
		'ë': 'e',
		'í': 'i',
		'ì': 'i',
		'î': 'i',
		'ï': 'i',
		'ó': 'o',
		'ò': 'o',
		'õ': 'o',
		'ô': 'o',
		'ö': 'o',
		'ú': 'u',
		'ù': 'u',
		'û': 'u',
		'ü': 'u',
		'ç': 'c',
		'Á': 'A',
		'À': 'A',
		'Ã': 'A',
		'Â': 'A',
		'Ä': 'A',
		'É': 'E',
		'È': 'E',
		'Ê': 'E',
		'Ẽ': 'E',
		'Ë': 'E',
		'Í': 'I',
		'Ì': 'I',
		'Î': 'I',
		'Ï': 'I',
		'Ó': 'O',
		'Ò': 'O',
		'Õ': 'O',
		'Ö': 'O',
		'Ô': 'O',
		'Ú': 'U',
		'Ù': 'U',
		'Û': 'U',
		'Ü': 'U',
		'Ç': 'C',
	};

	constructor(){ }

	/**
	 * removeCaracteresEspeciais
	 *
	 * Retorna uma string sem caracteres especiais
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  09/2017
	 * @param  string
	 * @return string
	 */
	public removeCaracteresEspeciais(palavra:string):string{
		return palavra.replace( /[^A-Za-z0-9\[\] ]/g, ch  => { return this.charsMap[ ch ] || ch ; });
	}
}


// WEBPACK FOOTER //
// ./src/services/caracteres-especiais.ts